import { ChangeEvent, createContext } from 'react'

interface GoogleMapContextProps {
  handleLocationName: (index: number) => (e: ChangeEvent<HTMLInputElement>) => void
  handleAddress: (index: number) => (v: string) => void
  handleLatitudeAndLongitude: (index: number) => (center: { lat: number; lng: number }) => void
  handleChangeRadius: (index: number) => (value: number) => void
}

export const LocationsMapContext = createContext<GoogleMapContextProps>({
  handleLocationName: () => () => {},
  handleAddress: () => () => {},
  handleLatitudeAndLongitude: () => () => {},
  handleChangeRadius: () => () => {},
})
